<template>
  <div id="not-found" class="page d-flex flex-column justify-content-center align-items-center">
    <div class="d-flex align-items-center mb-5">
      <font-awesome class="icon" icon="bug" fixed-width />
      <span>Page not found</span>
    </div>
    <p class="text-center">
      Sorry, we couldn't find the page you were looking for.
      <br />We suggest that you return to the main sections.
    </p>
    <router-link :to="this.path"><b-button variant="primary">go to homepage</b-button></router-link>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  props: ["page"],
  data() {
    return {
      path: `/not-found`
    }
  }
};
</script>

<style lang="scss">
#not-found {
  span {
    color: $primary-color;
    font-weight: 500 !important;
    font-size: 2.5em;
    line-height: 40px;
  }
  .icon {
    font-size: 3em;
    margin-right: 1em;
    * {
      color: $primary-color;
    }
  }
}
</style>
